export default __webpack_public_path__ + "static/media/think-emoji.179ede86.svg";